import {
  AddCashierRequest,
  AddCashierResponse,
} from "@services/models/Cashier/AddCashierModel";
import {
  GetCashierInfoRequest,
  GetCashierInfoResponse,
} from "@services/models/Cashier/GetCashierInfoModel";
import {
  GetCashierListModel,
  GetCashierListRequest,
} from "@services/models/Cashier/GetCashierListModel";
import {
  GetAutoTradeCashiersRequest,
  GetAutoTradeCashiersResponse,
  UpdateAutoTradeCashierStatusRequest,
  UpdateAutoTradeCashierStatusResponse,
} from "@services/models/Cashier/AutoTradeCashiersModel";
import {
  SetCashierStatusRequest,
  SetCashierStatusResponse,
} from "@services/models/Cashier/SetCashierStatusModel";
import {
  GetUpiConfigResponse,
  UpdateUpiConfigRequest,
  UpdateUpiConfigResponse,
} from "@services/models/Cashier/UpiConfigModel";
import { createApiClient } from "../api/createApiClient";
import { AxiosInstance } from "axios";

class CashierApiService {
  private api: AxiosInstance;
  constructor() {
    this.api = createApiClient();
  }

  public async getCashierList(
    data: GetCashierListRequest
  ): Promise<GetCashierListModel> {
    try {
      const response = await this.api.get("/adminPanel/getCashierList", {
        params: {
          page: data.page,
          rows: data.rows,
          search: data.search,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async getCashierInfo(
    data: GetCashierInfoRequest
  ): Promise<GetCashierInfoResponse> {
    try {
      const response = await this.api.get("/adminPanel/getCashierInfo", {
        params: {
          userId: data.userId,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async setCashierStatus(
    data: SetCashierStatusRequest
  ): Promise<SetCashierStatusResponse> {
    try {
      const response = await this.api.get<SetCashierStatusResponse>(
        "/adminPanel/setCashierStatus",
        {
          params: {
            setStatus: data.setStatus,
            userId: data.userId,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async giveUserCashierAccess(
    data: AddCashierRequest
  ): Promise<AddCashierResponse> {
    try {
      const response = await this.api.post<AddCashierResponse>(
        "/adminPanel/giveUserCashierAccess",
        {
          userId: data.userId,
          userEmail: data.userEmail,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async getAutoTradeCashiers(
    data: GetAutoTradeCashiersRequest
  ): Promise<GetAutoTradeCashiersResponse> {
    try {
      const params: Record<string, string | number> = {
        page: data.page ?? 1,
        limit: data.limit ?? 20,
      };

      if (data.status) params.status = data.status;
      if (data.search) params.search = data.search;
      if (data.groupId != null) params.groupId = data.groupId;

      const response = await this.api.get("/adminPanel/autoTrade/cashiers", {
        params,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  public async getUpiConfig(): Promise<GetUpiConfigResponse> {
    const response = await this.api.get<GetUpiConfigResponse>(
      "/adminPanel/upi/config",
    );
    return response.data;
  }

  public async updateUpiConfig(
    data: UpdateUpiConfigRequest,
  ): Promise<UpdateUpiConfigResponse> {
    const response = await this.api.post<UpdateUpiConfigResponse>(
      "/adminPanel/upi/config",
      data,
    );
    return response.data;
  }

  public async updateAutoTradeCashierStatus(
    data: UpdateAutoTradeCashierStatusRequest
  ): Promise<UpdateAutoTradeCashierStatusResponse> {
    try {
      const response = await this.api.put(
        "/adminPanel/autoTrade/cashiers/status",
        {
          id: data.id,
          userId: data.userId,
          paymentRecordId: data.paymentRecordId,
          action: data.action,
          reason: data.reason,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const cashierApis = new CashierApiService();
